import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconCardSquareGiant = function IconCardSquareGiant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 54"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#00204D",
    d: "M57.5.5v53H8.106V.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    d: "M38.483 16.554V53.5H4.604V16.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    d: "M21.75 29.69V53.5H.5V29.69z"
  }));
};